<template>
  <div>
    <div>

      <!-- <div class="btn-group mb-2">
        <button type="button" class="btn btn-default btn-lg dropdown-toggle ml-0 pl-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Block: {{ workoutPlan.workout_program.name }}
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            v-for="workoutProgram in availableWorkoutPrograms"
            v-bind:key="workoutProgram.id"
            :disabled="workoutPlan.workout_program_id == workoutProgram.id || workoutPlanIsApproved"
            class="dropdown-item"
            type="button"
            @click="changeWorkoutProgram(workoutProgram)"
          >{{workoutProgram.name}} <span v-if="workoutPlan.coaching_program_id == workoutProgram.id">(selected)</span>
          </button>
        </div>
      </div> -->

      <div class="alert alert-danger" v-if="notEnoughWeeks">
        This program requires {{ workoutPlan.workout_program.week_count }} weeks.
      </div>
      <!-- <div class="row no-gutters d-flex workoutplan-panel-overview-days-header">
        <div class="col-1">
        </div>
        <div class="col align-items-stretch" v-for="(day_idx, index) in 7" v-bind:key="day_idx">
          <h5 class="text-center">{{ ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][index] }}</h5>
        </div>
      </div> -->
      <!-- <draggable handle=".sort-week-handle" group="weeks" v-model="workoutPlan.weeks" @end="weekSortChanged"> -->
      <draggable handle=".sort-week-handle" group="weeks" v-model="sortedWeeks" @end="weekSortChanged">
        <div v-for="(week, index) in sortedWeeks" v-bind:key="week.id">
          <WorkoutPlanPanelWeek :initial-week="week" @week-updated="weekUpdated"></WorkoutPlanPanelWeek>
        </div>
        <button class="btn btn-link" @click="addWeek"><i class="mdi mdi-plus" />Add Week</button>
      </draggable>
      <button class="btn btn-success mt-2"  :disabled="!canApproveWorkoutPlan" @click="approveWorkoutPlan"><i class="mdi mdi-thumb-up" /> Approve Workout Plan</button>
      <button class="btn btn-secondary mt-2" v-if="!canApproveWorkoutPlan" @click="disapproveWorkoutPlan"><i class="mdi mdi-thumb-down" /> Disapprove Workout Plan</button>
      <!-- <button class="btn btn-light mt-2" @click="openSaveWorkoutProgramModal"><i class="mdi mdi-content-save" /> Save as new program</button> -->
      <!-- <div class="container-fluid horizontal-scrollable">
        <div class="row flex-row flex-nowrap">
          <div class="col-4 my-3" v-bind:key="day.id" v-for="day in selectedDays">
            <WorkoutPlanPanelDay :initial-day="day" @day-updated="weekUpdated" />
          </div>
        </div>
      </div> -->
    </div>
    <!-- <modal v-if="showAddWeekModal" @close="showAddWeekModal=false">
      <h3 slot="header">Add week to workout plan</h3>
      <div slot="body">
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="week-to-add-name">Name</label>
          </div>
          <div class="col">
            <input
              class="form-control"
              placeholder="Leave blank for default"
              id="week-to-add-name"
              required
              v-model="newWeek.name"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" @click="showAddWeekModal = false">Cancel</button>
        <button class="btn btn-primary" @click="addWeek">Add Week</button>
      </div>
    </modal> -->

  </div>
</template>
<script>
  import WorkoutPlanPanelWeek from '@coach/js/components/WorkoutPlanPanelWeek.vue'
  import WorkoutPlanPanelDay from '@coach/js/components/WorkoutPlanPanelDay.vue'
  import draggable from 'vuedraggable'
  export default {
    props: [
      'initialWorkoutPlan'
    ],
    components: {
      WorkoutPlanPanelWeek,
      WorkoutPlanPanelDay,
      draggable
    },
    data() {
      return {
        workoutPlan: this.initialWorkoutPlan,
        isLoading: false,
        // showAddWeekModal: false,
        showSaveWorkoutProgramModal: false,
        newWeek: {
          name: null
        },
        sortedWeeks: this.initialWorkoutPlan.weeks
      }
    },
    mounted() {
    },
    computed: {
      sortedWeekIds: function() {
        // return this.workoutPlan.weeks.map(function (a) { return a.id });
        return this.sortedWeeks.map(function (a) { return a.id });
      },
      workoutPlanIsFilesetType: function() {
        return this.workoutPlan.workout_program.type == 'fileset';
      },
      workoutPlanIsBuilderType: function() {
        return this.workoutPlan.workout_program.type == 'builder';
      },
      workoutPlanIsApproved: function() {
        return this.workoutPlan.approved_at != null;
      },
      canApproveWorkoutPlan: function() {
        return this.workoutPlanIsBuilderType
          && !this.notEnoughWeeks
          && !this.workoutPlanIsApproved;
      },
      numWeeks: function() {
        return this.workoutPlan.weeks.length;
      },
      notEnoughWeeks: function() {
        return this.numWeeks < this.workoutPlan.workout_program.week_count;
      }
    },
    methods: {
      // isCurrentProgram: function(program_id) {
      //   return program_id == this.$root.plan.program_id;
      // },
      // setNewWeekDefaultName: function() {
      //   this.newWeek.name = 'Week ' + (this.numWeeks+1);
      // },
      approveWorkoutPlan: function(approve_bool) {
        var _this = this;
        _this.isLoading = true;

        axios.put('/api/workout_plans/' + _this.workoutPlan.id, {
          approve: approve_bool == false ? false: true,
        }).then(function (response) {
          // _this.workoutPlan = response.data.data;
          _this.isLoading = false;
          _this.$toasted.success("Workout Plan Updated!")
          _this.weekUpdated();
        })
        .catch(e => {
          _this.$toasted.error(e.response.data.message);
          _this.isLoading = false;
        });
      },
      disapproveWorkoutPlan: function(){
        return this.approveWorkoutPlan(false);
      },
      weekSortChanged: function() {
        // console.log(this.workoutPlan.weeks);
        this.updateWeekSorting();
      },
      updateWeekSorting: function () {
        let _this = this;
        _this.isLoading = true;
        axios.post('/api/workout_plan_weeks/sort', {
          'workout_plan_week_ids': _this.sortedWeekIds,
        }).then(function (response) {
          // Update week positions.
          // for(var index = 0;index < _this.workoutPlan.weeks.length; index++) {
          //   _this.workoutPlan.weeks[index].position = index+1;
          // }
          _this.$toasted.success("Week Sorting Updated!")
          _this.weekUpdated();
          _this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          _this.errorBag = e.response.data;
        });
      },
      // addWeek: function() {
      //   var _this = this;
      //   // _this.setNewWeekDefaultName();
      //   _this.showAddWeekModal = true;
      //   this.$nextTick(
      //     function() {
      //       document.getElementById("week-to-add-name").focus();
      //       // this.$refs.exercise_filter_input.focus();
      //     }.bind(this)
      //   );
      // },
      // closeAddWeekModal: function() {
      //   this.showAddWeekModal = false;
      // },
      addWeek: function() {
        var _this = this;
        _this.isLoading = true;
        axios
          .post("/api/workout_plan_weeks", {
            workout_plan_id: this.workoutPlan.id,
            name: null,
          })
          .then(response => {
            // _this.workoutPlan.weeks.push(response.data.data)
            _this.weekUpdated();
            // _this.closeAddWeekModal();
          });
      },
      weekUpdated: function() {
        var _this = this;
        this.$emit('workout-plan-updated');
        // var _this = this;
        // _this.isLoading = true;
        // axios.get('/api/workout_plans/' + _this.workoutPlan.id).then(function (response) {
        //   _this.workoutPlan = response.data.data;
          _this.isLoading = false;
        // });
      },
    },
    watch: {
      initialWorkoutPlan: function (newVal,oldVal) {
        Vue.set(this, 'workoutPlan', newVal);
        Vue.set(this, 'sortedWeeks', newVal.weeks);
      }
    }
}
</script>
